//
// Angular
//
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, expand, catchError } from 'rxjs/operators';
import { Observable, throwError, forkJoin, of, EMPTY } from 'rxjs';
//
// App
//
import { SharedDataService } from '../../../core/services/shared-data.service';
import {CustomerDealSummary} from '../../../shared/model/api/CustomerDealSummary';
import {DealSummaryView} from '../../../shared/model/view-model/deal-summary-view';
import { ViewConstants } from 'src/app/constants';
import * as models from  '../../../shared/model/api/models';
//
// Libraries
//
import {isNil, cloneDeep} from 'lodash-es';
import { EnvironmentConfiguration } from '../../../environment/services/environment.configuration';
import { MonroneyLabel } from 'src/app/shared/model/api/MonroneyLabel';
import { ImageLabel } from 'src/app/shared/master-data/app-constant';
import { VehicleMatch, VehicleMatchRequest, VehicleMatchResponse } from 'src/app/shared/model/api/SignalResponse';

@Injectable({
    providedIn: 'root' 
})
export class WriteupsService {
    //private _path = '';
    private get dealerCode() {
        return this.sharedService.dealerCode;
    };
    private get userID() {
        return this.sharedService.loggedInUserId;
    };
    
    private readonly pageSize   = 500;
    darkTheme = false;
    constructor(private readonly httpClient: HttpClient, private readonly sharedService : SharedDataService, private readonly environment: EnvironmentConfiguration){}

    //
    // set the provided writeup ids status to hidden for the given logged in user
    //
    public UpdateHideUnhide(list : string[]){
        const path =
        `${this.environment.MST_BASE_SERVICE_URL  }user/${this.dealerCode}/preferences/${this.userID}`;
        const header = {
           // "userId" : this.userID,
            "dealerCode" : this.dealerCode,
            "leadIds" : [],
            "dealIds" : list
        };

        return this.httpClient.post(path, header);
    }


    //
    // Recursively fetch the data
    //
    public getAll(payload): Observable<DealSummaryView> {
        let currentPage = 1;
        let lastEvaluatedKey = {lastEvaluatedKey :null};
        return this.getWriteups(currentPage,lastEvaluatedKey, payload).pipe(
            expand(data => {
                if(this.hasNext(data,currentPage)){                                
                    currentPage = this.nextPage(data,currentPage);
                   lastEvaluatedKey = this.getLastEvaluatedKey(data);
                    return this.getWriteups(currentPage,lastEvaluatedKey, payload).pipe(
                        map(newResult => { 
                            if (newResult?.length === 0) { // Removing the lastEvaluatedKey when the newResult (Second API call) length is 0
                                data[data.length - 1].lastEvaluatedKey = null; 
                            }
                            return [...data, ...newResult];
                        } ));
                }
                else
                    {return EMPTY;}
            }),
            map( o => this.formatDataforDealView(o, payload))
        );
    }
    //
    // Specify if there is still more data to be fetched
    //
    private hasNext(data:CustomerDealSummary[], currentPage) :boolean{          
        const index = data.length - 1 > 0 ? data.length - 1 : 0;
        if (
            !isNil(data) && !isNil(data[0])&&
            (
                (currentPage > 0 && data[0].dealCount && data[0].dealCount !== 0 && currentPage * 500 < data[0].dealCount)
                    || 
                (!isNil(data[index].lastEvaluatedKey))
            )
        ){
            return true;
        }
        return false;
    }

    //
    // index of the next page for writeups
    //
    private nextPage(data:CustomerDealSummary[], currentPage: number ) :number{
        let pageNo=0;
        if(!isNil(data) && !isNil(data[0]) && currentPage > 0)
        {
            if(currentPage * 500 < data[0].dealCount){
                pageNo = currentPage + 1;
            }
        }
              
        return pageNo;
    }
    //
    // last loaded key for leads
    //
    private getLastEvaluatedKey(data:CustomerDealSummary[]){
        const index = data.length - 1 > 0 ? data.length - 1 : 0;
        let lastEvaluatedValue = {
            lastEvaluatedKey: {}
        };
        if (data[index].lastEvaluatedKey) {
            lastEvaluatedValue = {
                lastEvaluatedKey: data[index].lastEvaluatedKey
            };
        }

        return lastEvaluatedValue;
    }
    //
    // actual http call to fetch the data
    //
    private getWriteups(pageNo :number, lastEvaluatedKey: any, payload):Observable<CustomerDealSummary[]>{
        //
        // SDL : Why is this a post? should be a get
        //
        const LeadsPath = `${this.environment.MST_BASE_SERVICE_URL }retail-deals/dealers/${this.dealerCode}/offers/currentPagination/leads`; 
        const dealsPath = `${this.environment.MST_BASE_SERVICE_URL }retail-deals/dealers/${this.dealerCode}/offers/currentPagination?dealPage=${pageNo}`; 
        const byCustomerPath = `${this.environment.MST_BASE_SERVICE_URL }retail-deals/dealers/${this.dealerCode}/offers/writeUpsByCustomer?dealPage=${pageNo}`; 
        if(!isNil(payload)){
            let fromDate;
            let toDate;
            if(!isNil(payload.fromDate) && !isNil(payload.toDate)){
                fromDate=(new Date(payload.fromDate).toLocaleDateString('en-ca'));
                toDate = (new Date(payload.toDate).toLocaleDateString('en-ca'));
            }
            if(payload.activeTab == 'writeups' && isNil(payload.isAll))//being called in the initial page load and all date range filters except 'all'.
            {return this.httpClient.post<CustomerDealSummary[]>(dealsPath,{...{fromDate, toDate}});}
            else if(payload.activeTab == 'writeups' && !isNil(payload.isAll) && payload.isAll)//being called only for the 'all' filter in the writeups grid.
            {return this.httpClient.post<CustomerDealSummary[]>(dealsPath,{});}
            else if(payload.activeTab == 'by customer' && isNil(payload.isAll))//being called in the initial page load and all date range filters except 'all'.
            {return this.httpClient.post<CustomerDealSummary[]>(byCustomerPath,{...{fromDate, toDate}});}
            else if(payload.activeTab == 'by customer' && !isNil(payload.isAll) && payload.isAll)//being called only for the 'all' filter in the by customer grid.
            {return this.httpClient.post<CustomerDealSummary[]>(byCustomerPath,{});}
            else if(payload.activeTab == 'leads' && !isNil(payload.isAll) && payload.isAll)//being called only for the 'all' filter in the leads grid when refresh button is clicked.
            {return this.httpClient.post<CustomerDealSummary[]>(LeadsPath,lastEvaluatedKey);}
            else{;}//being called in the leads grid only when refresh button is clicked and passing the date filter date range as payload.
            return this.httpClient.post<CustomerDealSummary[]>(LeadsPath,{...lastEvaluatedKey, fromDate, toDate});
        }else{//being called in the initial page load of leads grid when the Leads button is clicked in the super menu. 
            return this.httpClient.post<CustomerDealSummary[]>(LeadsPath,lastEvaluatedKey);
        }
    }

    //
    // below methods may need to be moved somewhere else
    // 
    private formatDataforDealView(data: CustomerDealSummary[], payload?): DealSummaryView {
        this.darkTheme = this.sharedService.getDarkThemeValue();
        const dealSummaryData = this.setDefaulValue();
        const tempData: CustomerDealSummary[] = cloneDeep(data);
        const writeUps:CustomerDealSummary[] = [];
        const leads:CustomerDealSummary[] = [];
        const byCustomerWriteups:CustomerDealSummary[] = [];
        if(!isNil(payload) && payload.activeTab == 'by customer'){
            dealSummaryData.hiddenDeals = [];
            dealSummaryData.deals = [];
            dealSummaryData.leads = [];
            dealSummaryData.byCustomerWriteups = data;
            return dealSummaryData;
        }

        if (!isNil(tempData) && tempData.length > 0) {
            tempData.forEach(row => {
                if(row.deal?.creditFlag) {
                    row.deal = (Object as any).assign({}, row.deal, {
                        creditAppSent: 'Yes'
                    });
                }
                if (row?.customer?.firstName && row?.customer?.lastName) {
                    row.customer = (Object as any).assign({}, row.customer, {
                        customerFullName: `${row.customer.firstName ?
                            row.customer.firstName.toUpperCase() : row.customer.firstName
                             } ${  row.customer.lastName ? row.customer.lastName.toUpperCase()
                                : row.customer.lastName}`
                    });
                }
                if(row?.customer?.email) {
                    row.customer = (Object as any).assign({}, row.customer, {
                        email: row.customer.email
                    });
                }
                if(row?.customer?.email && row?.customer?.customerFullName) {
                    row.customer = (Object as any).assign({}, row.customer, {
                        customerFullNameAndEmail: `${row.customer.customerFullName  } ${  row.customer.email}`
                    });
                }
                row.isLead = false;
                row.dealIndicator = 'WRITE-UP';
                row.formattedVisitedStatus = 'N';
                if (row?.vehicle?.modelYear && row?.vehicle?.modelMarketingName) {
                    row.vehicle = (Object as any).assign({}, row.vehicle, {
                        modelName: `${row.vehicle.modelYear  } ${  row.vehicle.modelMarketingName}`
                    });
                }
                if (isNil(row?.vehicle?.grade)) {
                    row.vehicle = (Object as any).assign({}, row.vehicle, {
                        grade: ''
                    });
                }
    
                // TO DO: to be removed, when proper data is available in CustomerDealSummary
                if (row?.deal?.status) {
                    if (row.deal.status === 'PENDING REVIEW') {
                        row.dealStatus = (Object as any).assign('', row.dealStatus, {
                            dealStatus: ViewConstants.PENDING_APPROVAL_MST
                        }); 
                        row.deal.status=ViewConstants.PENDING_APPROVAL_MST;
                        
                    } else if (row.deal.status.toUpperCase() === 'INITIATED') {
                        row.dealStatus = (Object as any).assign('', row.dealStatus, {
                            dealStatus: ViewConstants.INITIATED
                        });
                        row.deal.status=ViewConstants.INITIATED;
                    }
                    else if (row.deal.status.toUpperCase() === 'FINALIZED') {
                        row.dealStatus = (Object as any).assign('', row.dealStatus, {
    
                            dealStatus: ViewConstants.DEAL_STATUS_FINALIZED
                       });
                       row.deal.status=ViewConstants.DEAL_STATUS_FINALIZED;
                    }
                    else if (row.deal.status.toUpperCase() === 'WRITE-UP PRICED') {
                        row.dealStatus = (Object as any).assign('', row.dealStatus, {
                            dealStatus: ViewConstants.WRITE_UP_PRICIED
                        });
                        row.deal.status='Write up Priced';
                    }
                    else if (row.deal.status.toUpperCase() === 'SENT TO FINANCE') {
                        row.dealStatus = (Object as any).assign('', row.dealStatus, {
                            dealStatus: ViewConstants.DEAL_STATUS_SENT_TO_FINANCE
                        });
                        row.deal.status=ViewConstants.DEAL_STATUS_SENT_TO_FINANCE;
                    }
                    else if (row.deal.status.toUpperCase() === 'DEALER APPROVED') {
                        row.dealStatus = (Object as any).assign('', row.dealStatus, {
                            dealStatus: ViewConstants.APPROVED_MST
                        });
                        row.deal.status=ViewConstants.APPROVED_MST;
                    }
                    else if (row.deal.status.toUpperCase() === 'TRADE APPROVED') {
                        row.dealStatus = (Object as any).assign('', row.dealStatus, {
                            dealStatus: ViewConstants.TRADE_APPROVED_MST
                        });
                        row.deal.status=ViewConstants.TRADE_APPROVED_MST;
                    }
                    else if (row.deal.status.toUpperCase() === 'EXPIRED') {
                        row.dealStatus = (Object as any).assign('', row.dealStatus, {
                            dealStatus: ViewConstants.EXPIRED_MST
                        });
                        row.deal.status=ViewConstants.EXPIRED_MST;
                    }
                    else if (row.deal.status.toUpperCase() === 'CANCELLED') {
                        row.dealStatus = (Object as any).assign('', row.dealStatus, {
                            dealStatus: ViewConstants.CANCELLED_MST
                        });
                        row.deal.status=ViewConstants.CANCELLED_MST;
                    }
                    else if (row.deal.status.toUpperCase() === 'DFI SUBMITTED') {
                        row.dealStatus = (Object as any).assign('', row.dealStatus, {
                            dealStatus: ViewConstants.DFI_SUBMITTED
                        });
                        row.deal.status=ViewConstants.DFI_SUBMITTED;
                    }
                    else if (row.deal.status.indexOf('_') > 0) {
                        row.dealStatus = (Object as any).assign('', row.dealStatus, {
                            dealStatus: row.deal.status.replace('_', ' ')
                        });
                    } 
                    else if (row.deal.status.toUpperCase() === ViewConstants.DEAL_STATUS_CONTRACT_APPROVED.toUpperCase()) {
                        row.dealStatus = (Object as any).assign('', row.dealStatus, {
                            dealStatus: ViewConstants.DEAL_STATUS_CONTRACT_APPROVED
                        });
                        row.deal.status=ViewConstants.DEAL_STATUS_CONTRACT_APPROVED;
                    } else {
                        row.dealStatus = (Object as any).assign('', row.dealStatus, {
                            dealStatus: row.deal.status
                        });
                    }
                }
                this.sharedService.getOnlineStatus(row.deal);
                
                // To Check if the we are getting null stock no from service then will show empty value
                if (!isNil(row) && !isNil(row.vehicle) &&
                    !isNil(row.vehicle.stockNumber) && (row.vehicle.stockNumber === "NULL" || row.vehicle.stockNumber === "null")) {
                    row.vehicle.stockNumber = ViewConstants.EMPTY_STRING;
                }
                /**
                 * Based on Thiru mail on Aug 02 2017
                 * Field name: dealType
                    Value: TradeIn (only if Trade In)
                    Value: Payment (only if APR / LEASE)
                    Value: TradeIn&Payment
    
                    Field Name: paymentType (this field will have value only if dealType is either Payment or TradeIn&Payment)
                    Value: APR or LEASE
                 */
                let tempDealType = '';
                let tempPaymentType = '';
                if (!isNil(row.deal.dealType)) {
                    tempDealType = row.deal.dealType;
                }
                if (!isNil(row.deal.paymentType)) {
                    tempPaymentType = row.deal.paymentType;
                }
    
                if ((tempDealType.toLowerCase() === 'tradein') ||
                    (tempDealType.toLowerCase() === 'tradein&payment')) {
                    tempDealType = 'Trade'
                } else {
                    tempDealType = '';
                }
    
                if (tempPaymentType.toLowerCase() === 'apr') {
                    tempPaymentType = 'Finance';
                } else if (tempPaymentType.toLowerCase() === 'lease') {
                    tempPaymentType = 'Lease';
                } else if (tempPaymentType.toLowerCase() === 'cash') {
                    tempPaymentType = 'Cash';
                }
    
                let offerType = '';
                if (tempDealType !== '' && tempPaymentType !== '') {
                    offerType = `${tempDealType  } - ${  tempPaymentType}`;
                } else if (tempDealType !== '') {
                    offerType = tempDealType;
                } else if (tempPaymentType !== '') {
                    offerType = tempPaymentType;
                }
    
                row.estimatedOffer = (Object as any).assign({}, {}, {
                    dealtype: offerType
                });
    
                // This condition is not needed in new Console ui we have it in old UI. 
                // Because of this initiated and expired count may not match with new and old UI

                // if(!isNil(row) && isNil(row.deal.dealType) && !isNil(row.deal.status) && row.deal.status === "EXPIRED")
                //     row.dealStatus = (<any>Object).assign('', row.dealStatus, { dealStatus: 'INITIATED'});
                
                // To Assign Lead Type
                // if (!isNil(row.origin) && !isNil(row.deal.sourceSystem) && !isNil(row.lead)
                //     && !isNil(row.lead.leadId)
                //     && row.origin.toUpperCase() === 'DG' && row.deal.sourceSystem.toUpperCase() === 'DG') {
                if (!isNil(row.lead) && !isNil(row.lead.origin) && !isNil(row.lead.leadId)) {
                    row.isLead = true;
                    row.dealIndicator = 'LEAD';//"ConfirmAvailability"EQUITY
                    let tempLeadType = '';
                    if (row.lead.leadType.toUpperCase() === 'PRICING') {
                        tempLeadType = ViewConstants.LEAD_TYPE_VEHICLE_SELLING_PRICE;
                    } else if (row.lead.leadType.toUpperCase() === 'DEALER') {
                        tempLeadType = 'Dealer Contact';
                    } else if (row.lead.leadType.toUpperCase() === 'EQUITY') {
                        tempLeadType = 'Equity';
                    } else if (row.lead.leadType.toUpperCase() === ViewConstants.DEAL_TYPE_CONFIRM_AVAILABILITY.toUpperCase()) {
                        tempLeadType = ViewConstants.DEAL_TYPE_CONFIRM_AVAILABILITY_LABEL;
                    } else if (row.lead.leadType.toUpperCase() === ViewConstants.DEAL_TYPE_START_PURCHASE.toUpperCase()) {
                        tempLeadType = ViewConstants.DEAL_TYPE_START_PURCHASE_LABEL;
                    } else if (row.lead.leadType.toUpperCase() === ViewConstants.DEAL_TYPE_TEST_DRIVE.toUpperCase()) {
                        tempLeadType = ViewConstants.DEAL_TYPE_TEST_DRIVE_LABEL;
                    } else if (row.lead.leadType.toUpperCase() === ViewConstants.DEALER_SITE_INVENTORY_INQUIRY) {
                        tempLeadType = ViewConstants.DEALER_SITE_INVENTORY_INQUIRY_LABEL;
                    } else if (row.lead.leadType.toUpperCase() === ViewConstants.DEALER_SITE_CONTACT_INQUIRY) {
                        tempLeadType = ViewConstants.DEALER_SITE_CONTACT_INQUIRY_LABEL;
                    } else if (row.lead.leadType.toUpperCase() === 'OFFER') {
                        tempLeadType = 'Offer';
                    } else if (row.lead.leadType.toUpperCase() === 'PAYMENTESTIMATION') {
                        tempLeadType = ViewConstants.LEAD_TYPE_PAYMENT;
                    } else if (row.lead.leadType.toUpperCase() === 'SHAREDSAVES') {
                        tempLeadType = ViewConstants.LEAD_TYPE_SHARED_SAVES;
                    } else if (row.lead.leadType.toUpperCase() === 'DEAL') {
                        tempLeadType = ViewConstants.LEAD_TYPE_DEAL;
                    }
                    else if (row.lead.leadType.toUpperCase() === 'CONTACTDEALER') {
                        tempLeadType = ViewConstants.LEAD_TYPE_CONTACT_DEALER;
                    }
                    row.estimatedOffer = (Object as any).assign({}, {}, {
                        dealtype: tempLeadType
                    });
    
                    row.updatedDate = (Object as any).assign('', row.updatedDate, {
                        updatedDate: this.formatDate(row.lead.updatedDate),
                        updatedDateAsDate: new Date(row.lead.updatedDate)
                    });
    
                    if (!isNil(row.lead.origin)) {
                        row.updatedOrigin = (Object as any).assign('', row.updatedOrigin, {
                            updatedOrigin: row.lead.origin
                        });
    
                        row.updatedBy = (Object as any).assign('', row.updatedBy, {
                            updatedBy: row.lead.origin
                        });
    
                        row.dealStatus = (Object as any).assign('', row.dealStatus, {
                            dealStatus: ''
                        });
                    }
    
                    if (!isNil(row.lead.visitedStatus)) {
                        if (row.lead.visitedStatus.toLowerCase() === 'visited') {
                            row.formattedVisitedStatus = 'Y';
                        }
                    }
    
                   
                }
    
                // For MST deals Assign origin
                if (!isNil(row.deal.origin)) {
                    row.updatedOrigin = (Object as any).assign('', row.updatedOrigin, {
                        updatedOrigin: row.deal.origin
                    });
                }
    
                if (!row.isLead && isNil(row.deal.origin)) {
                    row.updatedOrigin = (Object as any).assign('', row.updatedOrigin, {
                        updatedOrigin: 'MST'
                    });
                }
    
    
                // For Trade Deal type will show the trade vin(old vin).
                // If we have more than one trade in vin
                // then will show the first vin.
                /**
                 *Ask per discussion with Raghu, changing the logic  
                 */
                if (offerType === 'Trade') {
                    // if (row.tradeIns && row.tradeIns.length > 0) {
                    //     row.vehicle = (<any>Object).assign({}, row.vehicle, {
                    //         vin: row.tradeIns[0].vin
                    //     });
                    // } else {
                    //     row.vehicle = (<any>Object).assign({}, row.vehicle, {
                    //         vin: ''
                    //     });
                    // }
                    if (!(!isNil(row) && !isNil(row.vehicle) && !isNil(row.vehicle.vin))) {
                        row.vehicle = (Object as any).assign({}, row.vehicle, {
                            vin: ViewConstants.EMPTY_STRING, 
                            stockNumber: ViewConstants.EMPTY_STRING,
                            modelMarketingName: ViewConstants.EMPTY_STRING,
                            modelYear: ViewConstants.EMPTY_STRING
    
                        });
                    }
                }
    
                // To Format Visited status
    
                if (!isNil(row.deal.visitedStatus)) {
                    if (row.deal.visitedStatus.toLowerCase() === 'visited') {
                        row.formattedVisitedStatus = 'Y';
                    }
                }
    
                // To update sale type
                if(!isNil(row?.vehicle?.type)) {
                    if(row.vehicle.type.toLowerCase() === 'certified') {
                        row.vehicle.type = 'Certified';
                    }
                    else if(row.vehicle.type.toLowerCase() === 'new') {
                        row.vehicle.type = 'New';
                    }
                    else if(row.vehicle.type.toLowerCase() === 'used') {
                        row.vehicle.type = 'Used';
                    }
                }
    
                if (!isNil(row?.deal?.updatedDate)) {
                    row.updatedDate = (Object as any).assign('', row.updatedDate, {
                        updatedDate: this.formatDate(row.deal.updatedDate),
                        updatedDateAsDate: new Date(row.deal.updatedDate)
                    });
                }
    
                if (!isNil(row?.deal?.salesAssociate?.updatedBy)) {
                    row.updatedBy = (Object as any).assign('', row.updatedBy, {
                        updatedBy: row.deal.salesAssociate.updatedBy
                    });
                }
    
                if(!isNil(row?.deal?.salesAssociate?.createdBy)) {
                    row.createdBy = (Object as any).assign('', row.createdBy, {
                        createdBy: row.deal.salesAssociate.createdBy
                    });
                }
    
                if(!isNil(row?.deal?.salesAssociate?.salesConsultant)) {
                    row.deal.salesAssociate.salesConsultant = row.deal.salesAssociate.salesConsultant.split(' ').map( w =>  w.substring(0,1).toUpperCase()+ w.substring(1)).join(' ');
                    row.salesConsultant = (Object as any).assign('', row.salesConsultant, {
                        salesConsultant: row.deal.salesAssociate.salesConsultant
                    });
                }

                if(row.vehicle){
                    row.vehicle.vin_stocknum = (row.vehicle.vin || '') + (row.vehicle.stockNumber || '');
                    if(row.vehicle.carJellyImgURL) { 
                        row.vehicle.carJellyImgURL=this.imageExists(row.vehicle.carJellyImgURL)?row.vehicle.carJellyImgURL: (this.darkTheme ? ImageLabel.ICON_NO_IMAGE_NIGHT_HREF : ImageLabel.ICON_NO_IMAGE_HREF);
                    }
                }
                if(!isNil(row) && row.isLead) 
                    {leads.push(row);} 
                else 
                    {writeUps.push(row);}
                
            });
            writeUps.forEach(dt => {
                if (dt.deal.dealType == 'TRADEIN' 
                    && dt.vehicle  && (dt.vehicle.vin == null || dt.vehicle.vin == '')){
                    dt.vehicle.type ='Trade';
                }
                
              });
            dealSummaryData.hiddenDeals = writeUps.filter( e => e.deal.isHidden);
            dealSummaryData.deals = writeUps.filter( e => !e.deal.isHidden);;
            dealSummaryData.leads = leads;
        }     
        return dealSummaryData;
    }

    imageExists(url) {
        // this below code is commented in master branch to fix image not loading issue in grdd in production.
        // var image = new Image();
        // image.src = url;
        if (isNil(url) || url?.includes('undefined') || url?.includes('Object') || url === '') {
            return false;
        }
        return true;
    }

    /**
     * Method used to format the date value (if the value is less
     * than 9 then will 0 before the value)
     */
    private formatDateValue(value) {
        return value > 9 ? `${  value}` : `0${  value}`;
    }
    private  formatDate(date, convertUTC = true) {
        const modifiedDate = new Date(date);
        let updatedDate: any = {};
        if(convertUTC) {
            modifiedDate.setHours(modifiedDate.getHours() - 8);
        }
        const day = this.formatDateValue(modifiedDate.getDate());
        const month = this.formatDateValue(modifiedDate.getMonth() + 1);
        const year = modifiedDate.getFullYear();
        const hours = modifiedDate.getHours();
        const minutes = this.formatDateValue(modifiedDate.getMinutes());
        const h = (hours % 12) || 12;
        const ampm = hours < 12 ? 'AM' : 'PM';
        const timeString = `${this.formatDateValue(h)  }:${  minutes.toString()  } ${  ampm}`;
        // row.updatedDate = (<any>Object).assign('', row.updatedDate, {
        //     updatedDate: timeString + '&nbsp;&nbsp;&nbsp; ' + month + '.' + day + '.'
        //     + year
        // });
        updatedDate = `${timeString  } ${  month  }.${  day  }.${
             year}`;
        return updatedDate;
    }
    /*
     * Method used to set the default initial state of DealSummaryState
     */
    private setDefaulValue(): DealSummaryView {
        //let dataFormatter = <SharedFunctionService>new Object();
        const dealSummaryData: DealSummaryView = <DealSummaryView>new Object();
        dealSummaryData.deals = [];
        dealSummaryData.hiddenRecords = {};
        dealSummaryData.userView = {};
        dealSummaryData.successMessage = '';
        dealSummaryData.failureMessage = '';
        dealSummaryData.globalSearchFilterValue = '';
        dealSummaryData.originalDeals = [];
        dealSummaryData.customerLeads = [];
        dealSummaryData.byCustomerWriteups = [];
        return dealSummaryData;
    }

    //
    // HTTP call to fetch the Monroney Label Data
    //
    public getMonroneyLabelData(vehicleData: MonroneyLabel): Observable<any> {
        let path: string;
        if (!isNil(vehicleData) && vehicleData.type.toLowerCase() === ViewConstants.VEHICLE_TYPE_NEW) { // Service Call to fetch Monroney Label for NEW Vehicles
            path = `${this.environment.MST_BASE_SERVICE_URL  }dealers/${this.dealerCode}/monroney/label?vin=${vehicleData.vin}&includeInvPooling=true`;

            return this.httpClient.get<any>(path, { responseType: 'text' as 'json' })
                .pipe(
                    map((response: any) => response),
                    catchError(err => this.handleErrorDetail(err)))
        } else if (!isNil(vehicleData) && vehicleData.type.toLowerCase() === ViewConstants.VEHICLE_TYPE_CERTIFIED) { // Service Call to fetch Monroney Label for Certified Vehicles
            if (!this.sharedService.isUVIEndpoint) {
                path = `${this.environment.BASE_SERVICE_URL  }/dealer-inventory/usedvehicles/${vehicleData.vin}?dealerCd=${this.dealerCode}`;
            } else {
                path = `${this.environment.USED_VEHICLE_BASE_SERVICE_URL  }/used-vehicle-inventory/vehicles/${vehicleData.vin}?dealerCd=${this.dealerCode}`
            }
            return this.httpClient.get<any>(path)
                .pipe(
                    map((response: any) => response),
                    catchError(err => this.handleErrorDetail(err)))
        }
    }

    //
    // HTTP call to fetch the Used Vehicle Data
    //
    public getUsedVehicleData(vehicleData):Observable<any>{
        let path: string;
        if (!isNil(vehicleData)) {
            if(this.sharedService.isUVIEndpoint) { // UVI Endpoint is TRUE 
                path = `${this.environment.USED_VEHICLE_BASE_SERVICE_URL  }/used-vehicle-inventory/vehicles/${vehicleData.vin}?dealerCd=${this.dealerCode}`;
            } else { // UVI Endpoint is FALSE
                path = `${this.environment.BASE_SERVICE_URL  }/dealer-inventory/usedvehicles/${vehicleData.vin}?dealerCd=${this.dealerCode}`;
            }
            return this.httpClient.get<any>(path)
                .pipe(
                    map((response: any) => response),
                    catchError(err => this.handleErrorDetail(err)))
        }      
    }

    //
    // HTTP call to fetch the Reprint Declination Form Data
    //
    public getReprintDeclinationFormData(vehicleData): Observable<any> {
        if (!isNil(vehicleData)) {
            // Fetching Protection Products Data
            const path = `${this.environment.MST_BASE_SERVICE_URL  }digitalfi/dealers/${this.dealerCode}/worksheet/view`;
            return this.httpClient.post<any>(path, vehicleData)
                .pipe(
                    map((response: any) => response),
                    catchError(err => this.handleErrorDetail(err))
                )
        }
    }

    //
    // HTTP call to fetch the Deal Offer Details
    //
    public SummaryDealOffersLoadData(vehicleData): Observable<any> {
        if (!isNil(vehicleData)) {
            // Fetching Writeup details Data
            const path = `${this.environment.MST_BASE_SERVICE_URL  }retail-deals/dealers/${this.dealerCode}/offers/${vehicleData.dealTransactionId}`;
            return this.httpClient.get(path)
                .pipe(
                    map(response => response),
                    catchError(err => this.handleErrorDetail(err))
                )
        }
    }

    //
    // HTTP call to fetch the summary vspec load details
    //
    public SummaryVspecLoadData(vehicleVin): Observable<models.DownloadVspec> {
        
        if (!isNil(vehicleVin)) {
            // Fetching Writeup details Data
            const path = `${this.environment.BASE_SERVICE_URL  }/dealer-inventory/vehicles/${vehicleVin}?dealerCd=${this.dealerCode}&includeInvPooling=true`;
            return this.httpClient.get<any>(path)
            .pipe(
                map((response: models.DownloadVspec) => response),
                catchError(err => this.handleErrorDetail(err)))
        }
    }

    public getCustomerDetails(): Observable<models.CustomerInfo> {
        
            // Fetching Writeup details Data
            const path = `${this.environment.MST_BASE_SERVICE_URL  }customers/${this.sharedService.customerId}`;
            return this.httpClient.get<any>(path)
            .pipe(
                map((response: models.CustomerInfo) => response),
                catchError(err => this.handleErrorDetail(err)))
        
    }
    public getPaymentDetails(data): Observable<models.CustomerInfo> {
        
        // Fetching Writeup details Data
        const path = `${this.environment.MST_BASE_SERVICE_URL  }payment-nexgen/dealers/${this.sharedService.dealerCode}/payments`;
        return this.httpClient.post<any>(path,data)
        .pipe(
            map((response: models.CustomerInfo) => response),
            catchError(err => this.handleErrorDetail(err)))
    }


    public getVehicleMatches(data: VehicleMatchRequest  ): Observable<VehicleMatchResponse> {
        const url = `${this.environment.TRADE_SIGNAL_URL  }/insights/flags`;
        return this.httpClient.post<VehicleMatchResponse>(url, data)
          .pipe(
            map(response => {
              if (response.message === 'success' && response.data?.matches) {
                this.sharedService.signalRes = response
                return response
              } else {
                throw new Error('Unexpected response structure or failure message');
              }
            }),
            catchError(err => this.handleErrorDetail(err))
          );
      }

    public callDeepLinkApi(deepLink: string, dealerCode: string, crmCustomerId: string): Observable<any> {
        const url = `${this.environment.MST_BASE_SERVICE_URL}/deals/dealers/${dealerCode}/offers/${crmCustomerId}/send-crm?requestType=signal`;

        const requestData = {
            deepLinkUrl: deepLink
        };

        return this.httpClient.post<any>(url, requestData)
            .pipe(
                map(response => {
                    if (response === 'success') {
                        return { success: true, message: 'DeepLink API call successful', response };
                    } else {
                        throw new Error('DeepLink API did not return success');
                    }
                }),
                catchError(err => this.handleErrorDetail(err))
            );
    }

    public getDealDetailsForInitiatedModal(data): Observable<models.CustomerInfo> {
        
        // Fetching Writeup details Data
        const path = `${this.environment.MST_BASE_SERVICE_URL  }retail-deals/dealers/${this.dealerCode}/offers/${data.deal.dealTransactionId}`;
        return this.httpClient.get<any>(path)
        .pipe(
            map((response: models.CustomerInfo) => response),
            catchError(err => this.handleErrorDetail(err)))
    
}

    public getVehicleDetailsForInitiatedModal(data): Observable<models.VehicleDeal> {

        let path: string;
        if (data.type === 'Used' || data.type === 'Certified' || data.type === 'used' || data.type === 'certified' ) {
            if(this.sharedService.isUVIEndpoint) { // UVI Endpoint is TRUE 
                path = `${this.environment.USED_VEHICLE_BASE_SERVICE_URL  }/used-vehicle-inventory/vehicles/${data.vin}?dealerCd=${this.dealerCode}`;
            } else { // UVI Endpoint is FALSE
                path = `${this.environment.USED_VEHICLE_BASE_SERVICE_URL  }/dealer-inventory/usedvehicles/${data.vin}?dealerCd=${this.dealerCode}`;
            }
        }else if(data.type === 'New' || data.type === 'new'){
            path = `${this.environment.BASE_SERVICE_URL  }/dealer-inventory/vehicles/${data.vin}?dealerCd=${this.dealerCode}&includeInvPooling=true`;
        }
        return this.httpClient.get<any>(path).pipe(
                    map((response: models.VehicleDeal) => response),
                    catchError(err => this.handleErrorDetail(err)));

    }

    //
    // HTTP call to Fetch the V-Spec Token
    //
    // public SummaryVspecOpenInBrowser(data): Observable<any> {
    //     let vehicleData: models.vSpecBrowser = {};
    //     if(!isNil(data) && !isNil(data.selectedWriteUp.writeUps)) {
    //             vehicleData.vehicles = [];
    //             vehicleData.id = data.selectedWriteUp.writeUps[0].customer.email;
    //             vehicleData.custname = data.selectedWriteUp.writeUps[0].customer.customerFullName;
    //             vehicleData.dealerCd = data.selectedWriteUp.writeUps[0].customer.dealerCode;
    //             vehicleData.dealerPersonnel = {};
    //             vehicleData.dealerPersonnel.dealerCd = this.sharedService.dealerCode;
    //             vehicleData.dealerPersonnel.name = this.sharedService.getDealerNameFromToken();
    //             vehicleData.dealerPersonnel.email = this.sharedService.setAndGetValues('dealerPersonnelEmail', false, null);
    //             vehicleData.dealerPersonnel.phoneNo = this.sharedService.setAndGetValues('dealerPhoneNumberFromToken', false, null);
    //             vehicleData.dealerPersonnel.phoneType = 'work';
    //             vehicleData.dealerPersonnel.zipCode = this.sharedService.dealerZipCode;
    //             if(data.selectedWriteUp.VSpecNotes !== '') { // Message will not be empty if the selected option was 'Custom Landing Page'
    //                 vehicleData.message = data.selectedWriteUp.VSpecNotes; 
    //             } else { // Message will be empty if the selected option was 'Open in Browser'
    //                 vehicleData.message = 'MANAGEMENT_CONSOLE_OPEN_NEW_BROWSER'; // Hard Coding as of now as the empty string is resulting in an API error
    //             }
    //             for(let i=0; i<data.selectedWriteUp.writeUps.length; i++) {
    //                 let offer = {...data.selectedWriteUp.writeUps[i].deal.offer};
    //                 offer.paymentType = data.selectedWriteUp.writeUps[i].deal.paymentType;
    //                 offer.writeUpStatus = data.selectedWriteUp.writeUps[i].deal.status;
        
    //                 vehicleData.vehicles.push(
    //                     {
    //                         grade: data.selectedWriteUp.writeUps[i].vehicle.grade,
    //                         marketingSeries: data.selectedWriteUp.writeUps[i].vehicle.series,
    //                         model: {
    //                             modelCd: data.selectedWriteUp.writeUps[i].vehicle.modelCode,
    //                             marketingName: data.selectedWriteUp.writeUps[i].vehicle.modelMarketingName
    //                         },
    //                         media: [
    //                             {
    //                                 type: 'exterior',
    //                                 href: data.selectedWriteUp.writeUps[i].vehicle.carJellyImgURL
    //                             }
    //                         ],
    //                         price: {
    //                             totalMsrp: data.selectedWriteUp.writeUps[i].deal.offer.dealerSellingPrice
    //                         },
    //                         year: data.selectedWriteUp.writeUps[i].vehicle.modelYear,
    //                         unitId: 123456789,
    //                         vin: data.selectedWriteUp.writeUps[i].vehicle.vin,
    //                         offer: offer,
    //                         protectionProducts: [],
    //                         dealTransactionId: data.selectedWriteUp.writeUps[i].deal.dealTransactionId,
    //                         vehicleType: data.selectedWriteUp.writeUps[i].vehicle.type,
    //                         brand: data.selectedWriteUp.writeUps[i].vehicle.brand
    //                     }
    //                 )
        
    //             }
    //             vehicleData.vehicles.forEach(vehicle => {
    //                 data.productsData.forEach(product => {
    //                     if(vehicle.dealTransactionId === product.dealTransactionId) {
    //                         vehicle.protectionProducts = [...product.protectionProducts]
    //                     }
    //                 })
    //             })

    //             vehicleData.vehicles.forEach(vehicle => {
    //                 delete vehicle.dealTransactionId;
    //              });

    //         let path = this.environment.BASE_SERVICE_URL + `/d2c-comms/leads/vspec`;
    //             return this.httpClient.post<any>(path, vehicleData)
    //                 .pipe(
    //                     map((response: any) => response),
    //                     catchError(err => this.handleErrorDetail(err))
    //                 )

    //     }                      
    // }

    getProtectionProducts(data: any): Observable<any> {
        const responseArray: any = [];
        if(data?.length > 0) {
            data.forEach(element => responseArray.push(this.httpClient.get(element)));
            return forkJoin(responseArray);
        }else{
            return responseArray;
        }
    }


    handleErrorDetail(error) {
        let errorMessage = '';
        if (error?.error instanceof ErrorEvent) {
            // client-side error
            errorMessage = `Error: ${error.error.message}`;
        } else {
            // server-side error
            errorMessage = error?.error?.errorCode;
        }
        if(errorMessage && errorMessage.length <= 0)
          {errorMessage = `Error: ${error?.message}`;}
        return throwError(() =>errorMessage);
    }

    verifyAddress(custAddress)
    {
        return new Promise((resolve) => {
			 
				if (!custAddress.street && !custAddress.city && !custAddress.state && !custAddress.zipCode) {
					resolve(custAddress);
				}
				else {
					custAddress.street = custAddress.street ?? '';
					custAddress.city = custAddress.city ?? '';
					custAddress.state = custAddress.state ?? '';
					custAddress.zipCode = custAddress.zipCode ?? '';

					//.map(res => res.json())
					// '&county=' + custAddress.county +
					this.httpClient.get(`${this.environment.MST_BASE_SERVICE_URL  }dealers/${  this.dealerCode  }/address-verification?address=${  custAddress.street   }&city=${  custAddress.city  }&state=${  custAddress.stateCode  }&zipCode=${  custAddress.zipCode  }&country=USA`)
						.pipe(
							map((res: any) => {
								return res;
							}),
							catchError((res: any) => {
								if (res.hasOwnProperty('message') && (res.message.toString().toLowerCase().indexOf(ViewConstants.timeoutErrorCode) > -1)) {
									return of(ViewConstants.timeoutErrorCode);
								} else {
									return of(res);
								}
							})
						)
						.subscribe(data => {
							if (data!==undefined && data.Records !== undefined && data.Records.length > 0) {
								const resultsCodes = data.Records[0].Results.split(',');
								const resultsCodesFromDoc = Object.keys(ViewConstants.addressResultsCodes);
								const finalResultCodes = resultsCodes.filter(item =>
									resultsCodesFromDoc.indexOf(item) >= 0);								
                                    const systemAddress = {...data.Records[0]};
                                    resolve(systemAddress);
							} 
                            else {
								resolve(custAddress);
							}
						}, error => {
							resolve(custAddress);
						});
				
			} 
		});
    }
    
    markAsPresold(data: any): Observable<any> {
        const unitId = data?.unitId;
        const path = `${this.environment.PRESOLD_BASE_SERVICE_URL}/vehicle-presold/presold/${unitId}`;
        return this.httpClient.put<any>(path, data.payload)
            .pipe(
                map((response: any) => response),
                catchError(err => this.handleErrorDetail(err))
            );
    }
}